export default "__VITE_ASSET__DwiwjSoa__"